import React from 'react';
import PropTypes from 'prop-types';

import { ConfirmDelete, Typography } from '@metarouter-private/mr-mui';

export default function DeleteEvent({ deleteEventName, playbookState, setDeleteEventName, navState }) {
  const handleConfirm = () => {
    playbookState.deleteEvent(deleteEventName);
    navState.setEvent(null);

    const sortedEvents = playbookState.getSortedEvents();
    const firstEvent = deleteEventName === sortedEvents[0] ? sortedEvents[1] : sortedEvents[0];
    const defaultEvent = firstEvent ?? 'newEvent';
    navState.setEvent(defaultEvent);
    setDeleteEventName(null);
  };

  const handleClose = () => {
    setDeleteEventName(null);
  };

  return (
    <ConfirmDelete
      open={true}
      onClose={handleClose}
      title="Delete Event"
      message={
        <Typography>
          Delete <strong>{deleteEventName}</strong> from Event Parameters?
        </Typography>
      }
      onConfirm={handleConfirm}
      ConfirmProps={{ 'data-test-id': 'ConfirmDeleteEvent' }}
    />
  );
}

DeleteEvent.propTypes = {
  deleteEventName: PropTypes.string.isRequired,
  playbookState: PropTypes.object.isRequired,
  setDeleteEventName: PropTypes.func.isRequired,
  navState: PropTypes.object.isRequired,
};
